var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy198(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M73.1,45.6c-0.2-0.2-0.4-0.3-0.7-0.3h-4.6l0-11.4c0-10-8.1-18-18-18c-10,0-18,8.1-18,18v11.4h-4.9 c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7v35.9c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3h45.6c0.3,0,0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.4,0.3-0.7V46.4C73.4,46.1,73.3,45.8,73.1,45.6z M33.7,34c0-4.4,1.8-8.4,4.7-11.3c2.9-2.9,6.9-4.7,11.3-4.7 c4.4,0,8.4,1.8,11.3,4.7c2.9,2.9,4.7,6.9,4.7,11.3v11.4H62l0-12.2c0-6.8-5.5-12.2-12.2-12.2c-6.8,0-12.2,5.5-12.2,12.2v12.2h-3.8 V34z M39.5,45.4V33.1c0-2.8,1.1-5.4,3-7.2c1.9-1.9,4.4-3,7.2-3c2.8,0,5.4,1.1,7.2,3c1.9,1.9,3,4.4,3,7.2v12.2H39.5z M27.8,47.4 h43.6l0,33.9H27.8V47.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy198);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-198.fdea877ce1a4c86e5b2e4ae23f79bb25.svg";
export { ForwardRef as ReactComponent };